import '.ax{flex:1 1 0;}.ssr-plugin'
import '.g4{border-radius:var(--border-radius-image);}.ssr-plugin'
import '.hp{background-color:var(--palette-steady-stone);}.ssr-plugin'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { Image } from '@app/components/core/image/Image'

export type LandingContentImageColumnProps = {
  imageSrc?: string
}

const LandingContentImageColumn = ({
  imageSrc,
}: LandingContentImageColumnProps) => {
  const isMobile = useMediaQuery()

  const frameHeight = isMobile ? '21rem' : '31rem'

  return imageSrc ? (
    <div className="ax g4"
      style={{
        height: frameHeight,}}
    >
      <Image
        src={imageSrc}
        alt="Landing content image"
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  ) : (
    <div className="ax g4 hp"
      style={{
        minHeight: isMobile ? '20.5rem' : '30.5rem',}}
    />
  )
}

export default LandingContentImageColumn
